import { render, staticRenderFns } from "./CompanieInfo.vue?vue&type=template&id=22e2ce3b"
import script from "./CompanieInfo.vue?vue&type=script&lang=js"
export * from "./CompanieInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports